var _rect, _path, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoAds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.16 13a5.2 5.2 0 00-1.44-.2h-3.34v4.97l1.96-1.96v-1.18h1.18L24.16 13zm-2.82 4.13v3h1.38a2.93 2.93 0 002.01-.8c.25-.24.45-.52.59-.85a2.87 2.87 0 00-.59-3.06 2.6 2.6 0 00-1.04-.63l1.41-1.42a4.53 4.53 0 012.09 2.22c.24.55.36 1.15.36 1.79a4.42 4.42 0 01-1.37 3.24 4.85 4.85 0 01-3.46 1.33h-3.34V19.1l1.96-1.96zm-4.01 2.7l-2.71-7.03h-2.23l-3.53 9.15h2.1l.78-2.09h3.53l.55 1.47 1.5-1.5zm-.8 2.12l1.16-1.17.46 1.17h-1.63zm-3-6.86h-.05l-1.09 3h2.23l-1.09-3z",
    fill: "#ED0A34"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.04,
    y: 10.85,
    width: 1.6,
    height: 18.66,
    rx: 0.47,
    transform: "rotate(45 24.04 10.85)",
    fill: "#ED0A34"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAzNiI+PHJlY3Qgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiByeD0iMTgiIGZpbGw9IiNmZmYiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI0LjE2IDEzYTUuMiA1LjIgMCAwIDAtMS40NC0uMmgtMy4zNHY0Ljk3bDEuOTYtMS45NnYtMS4xOGgxLjE4TDI0LjE2IDEzWm0tMi44MiA0LjEzdjNoMS4zOGEyLjkzIDIuOTMgMCAwIDAgMi4wMS0uOGMuMjUtLjI0LjQ1LS41Mi41OS0uODVhMi44NyAyLjg3IDAgMCAwLS41OS0zLjA2IDIuNiAyLjYgMCAwIDAtMS4wNC0uNjNsMS40MS0xLjQyYTQuNTMgNC41MyAwIDAgMSAyLjA5IDIuMjJjLjI0LjU1LjM2IDEuMTUuMzYgMS43OWE0LjQyIDQuNDIgMCAwIDEtMS4zNyAzLjI0IDQuODUgNC44NSAwIDAgMS0zLjQ2IDEuMzNoLTMuMzRWMTkuMWwxLjk2LTEuOTZabS00LjAxIDIuNy0yLjcxLTcuMDNoLTIuMjNsLTMuNTMgOS4xNWgyLjFsLjc4LTIuMDloMy41M2wuNTUgMS40NyAxLjUtMS41Wm0tLjggMi4xMiAxLjE2LTEuMTcuNDYgMS4xN2gtMS42M1ptLTMtNi44NmgtLjA1bC0xLjA5IDNoMi4yM2wtMS4wOS0zWiIgZmlsbD0iI0VEMEEzNCIvPjxyZWN0IHg9IjI0LjA0IiB5PSIxMC44NSIgd2lkdGg9IjEuNiIgaGVpZ2h0PSIxOC42NiIgcng9Ii40NyIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMjQuMDQgMTAuODUpIiBmaWxsPSIjRUQwQTM0Ii8+PC9zdmc+";
export { SvgNoAds as ReactComponent };